<script setup lang="ts">
import type TripPackage from '@itinerary/trip/TripPackage';
import SegmentView from '@components/util/trip/SegmentView.vue';

const { selectable = undefined, inPanel, package: pkg } = defineProps<IProps>();
interface IProps {
    package: TripPackage;
    inPanel?: boolean;
    selectable?: boolean;
}
const modelValue = defineModel<boolean>();
const computedSelectable = computed(() => {
    if (selectable === undefined) {
        return !inPanel || modelValue.value;
    }
    return selectable;
});
const firstSegment = computed(() => pkg.segments[0]);
const label = computed(() => {
    if (inPanel && modelValue) {
        return `یک ${pkg.vehicleName} برای شما یافت شد و در فرآیند صدور قرار گرفت!`;
    }
    if (modelValue.value) {
        return 'به لیست رزرو اضافه شد';
    }
    return 'اضافه کردن به لیست رزرو';
});
const reserve = () => {
    if (!inPanel) {
        modelValue.value = !modelValue.value;
    }
};
</script>

<template>
    <div
        class="auto-card-container"
        :class="{
            selected: modelValue,
            'in-panel': inPanel,
        }"
        @click="reserve"
    >
        <section class="info-section">
            <mr-checkbox
                v-if="computedSelectable"
                v-model="modelValue"
                class="mr-checkbox"
                :label
                :read-only="inPanel"
            />
            <SegmentView
                :segment="firstSegment"
                :vehicle-type="pkg.vehicleType"
                in-auto-reserve
            />
        </section>
    </div>
</template>

<style lang="scss" scoped>
.auto-card-container {
    @include shadow;
    display: flex;
    width: 100%;
    background: white;
    border-radius: 12px;
    cursor: pointer;
    flex-direction: column;
    align-items: stretch;
    padding: 16px;

    &.selected {
        background: usePalette($p-blue, $p-100);
        border: 1px solid usePalette();
    }

    &.in-panel {
        cursor: pointer;
    }

    .info-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: stretch;

        .mr-checkbox {
            margin-bottom: 8px;
        }
    }
}
</style>
